import { actionCreatorFactory } from 'typescript-fsa';
import { ArrowType, OrderType, DesignSet } from '@app/react/const/type';

const actionCreator = actionCreatorFactory();

export interface IAddCartParam {
    csrf: string;
    arrowType: ArrowType;
    orderType: OrderType;
    parts: DesignSet;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IAddCartResult { }

export interface IAddCartError {
    status: number; // http status code
    statusText: string; // http status message
}

export const addCartAction = actionCreator.async<
IAddCartParam, IAddCartResult, IAddCartError
>('addCart');

export const IAddCartAction = typeof addCartAction;
